import cn from 'classnames';
import repeat from 'lodash/repeat';
import React__default, { useState, useEffect, useMemo, useCallback } from 'react';
import { NumberInput } from '@sravni/react-design-system';
import modules_13b53a7e from './styles.module.less.js';

const ExtraZeroInput = ({ value: propValue, digitSize = 0, postfix: propPostfix, min, max, onChange: propOnChange, className, ...rest }) => {
    const [value, setValue] = useState(() => propValue);
    useEffect(() => {
        setValue(propValue);
    }, [propValue]);
    const [multiplier] = useState(() => 10 ** digitSize);
    const inputValue = value ? value / multiplier : value;
    const inputMin = useMemo(() => (typeof min === 'number' ? Math.ceil(min / multiplier) : undefined), [min, multiplier]);
    const inputMax = useMemo(() => (typeof max === 'number' ? Math.floor(max / multiplier) : undefined), [max, multiplier]);
    const onChange = useCallback((_value) => {
        const realValue = _value * multiplier;
        setValue(realValue);
        propOnChange?.(realValue);
    }, [propOnChange, multiplier]);
    const postfix = useMemo(() => [repeat('0', digitSize), propPostfix || ''].filter(Boolean).join(' '), [digitSize, propPostfix]);
    return (React__default.createElement(NumberInput, { ...rest, className: cn(modules_13b53a7e.input, className), value: inputValue, postfix: postfix, min: inputMin, max: inputMax, onChange: onChange }));
};

export { ExtraZeroInput };
//# sourceMappingURL=extroZero.input.js.map
